import { Container } from '@chakra-ui/react';
import { DateRange } from 'components/DateRange';
import { Input } from 'components/Input';
import { Visible } from 'components/Visible';
import { useEffect, useState } from 'react';
import { DateRangeState } from 'utils';

type DateRangeWithInputProps = {
    placeholder: string;
    onChange: (dates: DateRangeState) => void;
  tabChanged: boolean;
    maxWidth?: string;
}
const DateRangeWithInput = ({placeholder, onChange, tabChanged, maxWidth}: DateRangeWithInputProps) => {
    const [dateRangeVisible, setDateRangeVisible] = useState(false);
    const [datesSelected, setDatesSelected] = useState<DateRangeState>()
 
    useEffect(() => {
        setDateRangeVisible(false);
    }, [tabChanged])
    
    return (
      <Container width={maxWidth || '100%'}>
        <Input
            variant='filled'
            defaultValue={datesSelected?.startDate?.getDate() ? `${datesSelected?.startDate?.getDate() || ''} - ${datesSelected?.endDate?.getDate() || ''}` :''}
            onFocus={() => setDateRangeVisible(!dateRangeVisible)}
            placeholder={placeholder}
        />
        <Visible when={dateRangeVisible}>
            <Container position="absolute">
                <DateRange onChange={(dates) => {onChange(dates); setDatesSelected(dates)}} />
            </Container>
        </Visible>
      </Container>
    );
}

export {DateRangeWithInput};